import { IRowData } from "@multiweb/types/contracts";
import { registerCustomElement } from "../UI.ElementarControls/Utils/CustomElementUtils";
import { CheckedDataRow } from "./DataGridSubcontrols/Components/CheckedDataRow";
import { ListDataGrid } from "./ListDataGrid";

export class CheckedDataGrid extends ListDataGrid<CheckedDataRow> {
    public isShowed: boolean;
    private _selectedItems: Set<CheckedDataRow>;

    public get selectedItems(): IterableIterator<CheckedDataRow> {
        return this._selectedItems.values();
    }

    protected override _constructor(): void {
        super._constructor();

        this._selectedItems = new Set<CheckedDataRow>();
        this.fetchCount = 15;

        this.classList.add("CheckedDataGrid");
        //this.mainList_div.className = "compactListDiv";
        this.dataRows = new Array<CheckedDataRow>();
        this.selectedRows = new Array<CheckedDataRow>();
        this.headerRow.visible = false;

        this.registerDataRowFactory(() => new CheckedDataRow());
    }

    protected override async _attachDataGrid(): Promise<any> {
        await super._attachDataGrid();
    }

    protected override _createRow(data: IRowData): CheckedDataRow {
        const dataRow = this._dataRowFactory(this, data);
        dataRow.init(data, this, this._createRowControlElement(dataRow));

        dataRow.afterAttach(() => {
            if (this.isSelectedAll)
                dataRow.isSelected = true;
            dataRow.registerEventListener("checkedChange", (e: CustomEvent) => {
                const el = e.detail.item as CheckedDataRow;

                if (el.isChecked)
                    this._selectedItems.add(el);
                else {
                    for (const si of this._selectedItems) {
                        if (si.dataKey == el.dataKey) {
                            this._selectedItems.delete(si);
                            break;
                        }
                    }
                }
            });
        });

        this.dataRows.push(dataRow);

        return dataRow;
    }

    public override insertExistingRecord(dataRow: IRowData): CheckedDataRow {
        return this.insertNewRecord(dataRow);
    }

    public override insertNewRecord(dataRow: IRowData): CheckedDataRow {
        const beforeRow = this.selectedRows.length > 0 && this.dataRows && this.dataRows.length > 0 ? (this.dataRows.indexOf(this.selectedRows[0]) > -1 ? this.selectedRows[0] : undefined) : (this.dataRows.length > 0 ? this.dataRows[0] : undefined);
        const newRow = this._dataRowFactory(this, dataRow);
        const dataSource = this.dataSource;
        newRow.init(dataRow, this, this._createRowControlElement(newRow));
        newRow.render();
        newRow.dataKey = dataRow[dataSource.dataKey].valueOf();

        this.emptyMessage.visible = false;

        if (beforeRow)
            this._dataTable.insertBefore(newRow as HTMLElement, beforeRow as HTMLElement);
        else
            this._dataTable.appendChild(newRow as HTMLElement);

        if (beforeRow) {
            const addIndex = this.dataRows.indexOf(beforeRow);
            this.dataRows.splice(addIndex, 0, newRow); //.push(newRow);
        } else {
            this.dataRows.push(newRow);
        }

        return newRow;
    }
}

registerCustomElement("tsc-CheckedDataGrid", CheckedDataGrid);
